/** The locale the formatters fall back to for any unmapped language. */
export const DEFAULT_LOCALE = "en-US";
